import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=3047086e&scoped=true&"
import script from "./Payments.vue?vue&type=script&lang=ts&"
export * from "./Payments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3047086e",
  null
  
)

export default component.exports